import {FormControl, FormGroup, Validators} from "@angular/forms";
import {toString} from "../helpers/helpers";

export interface ContactModel {
  id?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  phoneNumber2?: string;
  emailAddress?: string;
  businessPartnerId?: string;
  locale?: string;
  country?: string;
  language?: string;
  sourceSystem?: string;
  itsmContactId?: string;
}

export function contactModelFactory(json?: any): ContactModel {
  json = json || {};

  const firstName = toString(json.firstName);
  const lastName = toString(json.lastName);

  return {
    id: toString(json.id),
    firstName,
    lastName,
    phoneNumber: toString(json.phoneNumber),
    phoneNumber2: toString(json.phoneNumber2),
    emailAddress: toString(json.emailAddress),
    businessPartnerId: toString(json.businessPartnerId),
    locale: toString(json.locale),
    country: toString(json.country),
    language: toString(json.language),
    sourceSystem: toString(json.sourceSystem),
    itsmContactId: toString(json.itsmContactId), // NOTE this must be set this way so that TMC knows what's valid
  };
}

export function contactModelFormGroup(contact?: ContactModel): FormGroup {
  contact = contact || contactModelFactory();
  return new FormGroup({
    id: new FormControl("", [Validators.maxLength(50)]),
    firstName: new FormControl(contact.firstName, [Validators.maxLength(40)]),
    lastName: new FormControl(contact.lastName, [Validators.maxLength(40)]),
    phoneNumber: new FormControl(contact.phoneNumber, [Validators.maxLength(40)]),
    phoneNumber2: new FormControl(contact.phoneNumber2, [Validators.maxLength(40)]),
    emailAddress: new FormControl(contact.emailAddress, [Validators.required, Validators.maxLength(100)]),
    businessPartnerId: new FormControl(contact.businessPartnerId, [Validators.maxLength(11)]),
    locale: new FormControl(contact.locale, [Validators.maxLength(10)]),
    sourceSystem: new FormControl(contact.sourceSystem, [Validators.maxLength(10)]),
    itsmContactId: new FormControl(contact.itsmContactId, [Validators.maxLength(50)]),
  });
}
